import React, { Component } from 'react';
import DepositoPage from './DepositoPage';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';
import ChatPage from './ChatPage';
import PreProjetoPage from './PreProjetoPage'
import InstrucoesPreProjetoPage from './InstrucoesPreProjetoPage'
import { inject, observer } from 'mobx-react';
import { ALUNO_STORE, AlunoStore, PREPROJETO_STORE, PreProjetoStore } from '../../Store';
import { MonografiaNotFound } from './NotFound';

interface IState {
  dentroDoPeriodoDeIncricao: boolean
}

interface IProps extends RouteComponentProps<string> {
  [ALUNO_STORE]: AlunoStore
  [PREPROJETO_STORE]: PreProjetoStore
}

@inject(ALUNO_STORE, PREPROJETO_STORE)
@observer
export default class AlunoPage extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      dentroDoPeriodoDeIncricao: true
    }
  }

  getAluno = async () => {
    const alunoStore = this.props[ALUNO_STORE]
    await alunoStore.fecthAlunoParaAutenticacaoPreProjeto()
  }

  verificarSePeriodoDeIncricao = async () => {
    const preProjetoStore = this.props[PREPROJETO_STORE]
    await preProjetoStore.getParamsPreProjeto()
    const { parametros } = preProjetoStore

    const hoje = new Date()
    const inicio = new Date(parametros && parametros.dataDeInicioInscricoes)
    const fim = new Date(parametros && parametros.dataDeFimInscricoes)

    if (hoje >= inicio && hoje <= fim) {
      this.setState({ dentroDoPeriodoDeIncricao: true })
    } else {
      this.setState({ dentroDoPeriodoDeIncricao: false })
    }
  }

  async componentDidMount() {
    await this.getAluno()
    await this.verificarSePeriodoDeIncricao()
  }

  renderMainComponent = () => {
    const alunoStore = this.props[ALUNO_STORE]
    const preProjetoStore = this.props[PREPROJETO_STORE]
    const { aluno } = alunoStore
    const { parametros } = preProjetoStore

    if (aluno && aluno.monografia) return DepositoPage

    if (aluno && aluno.preProjeto) return PreProjetoPage

    if (aluno && parametros && aluno.serie == parametros.serie && aluno.sit == 'M' && this.state.dentroDoPeriodoDeIncricao) return InstrucoesPreProjetoPage

    return MonografiaNotFound
    }

    render() {
      return (
        <Switch>
          <Route path={`${this.props.match.path}/orientacoes`} component={ChatPage} />
          <Route path={`${this.props.match.path}/inscricao`} component={PreProjetoPage} />
          <Route path={this.props.match.path} component={this.renderMainComponent()} />
        </Switch>
      )
    }
  }